import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, FormLabel, Row } from "react-bootstrap";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { SearchOperation } from "../../../../utils/ApiUtils";
import PageTitle from "../../../layouts/PageTitle";
import { Grid } from "../../../components/Grid/Grid";
import { Columns } from "./Columns";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import StatusFilterSelect, { DEFAULT_STATUS, buildStatusFilter } from "../../../components/Common/Filter/StatusFilterSelect";

const PlanList = () => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    // A grade já abre só com ativos, então o filtro nasce em Ativo: o campo mostra o recorte
    // que está valendo em vez de parecer vazio. Mesmo padrão das telas de cadastro.
    const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUS);
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const f = [];
        if (name) {
            f.push({ field: "name", value: name, operation: SearchOperation.MATCH });
        }
        f.push(buildStatusFilter(statusFilter));
        setFilters(f);
    };

    /**
     * Pergunta do Remover quando o plano tem assinantes: remover também exclui o plano no provedor
     * de pagamento, e para só tirar o plano das vendas novas basta desativá-lo no cadastro. Sem
     * assinantes, vale a pergunta padrão da grade.
     */
    const removeConfirmMessage = (selectedRows) => {
        const withSubscribers = selectedRows.find((row) => Number(row.openSubscriptionCount) > 0);
        return withSubscribers
            ? t("plan_remove_confirm", { name: withSubscribers.name, count: Number(withSubscribers.openSubscriptionCount) })
            : null;
    };

    const handleClear = () => {
        setName("");
        setStatusFilter(DEFAULT_STATUS);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("plan")} motherMenu={t("subscriptions")} />

            <FilterAccordion onSearch={handleSearch} onClear={handleClear}>
                <Row className="g-3">
                    <Col md={4}>
                        <FormLabel>{t("name")}</FormLabel>
                        <InputText
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder={t("plan_name_placeholder")}
                        />
                    </Col>
                    <Col md={3}>
                        <StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />
                    </Col>
                </Row>
            </FilterAccordion>

            <Grid
                height="560px"
                path={Api.subscription.plan}
                columns={Columns(t)}
                rowSelection="single"
                route={MenuConfig.subscription.plan.route}
                pagination="true"
                filters={filters}
                // A situação já é escolhida no filtro; o atalho "Inativos" do menu Ações mandaria
                // um segundo recorte de situação e os dois juntos anulariam a busca.
                hideInactiveToggle
                removeConfirmMessage={removeConfirmMessage}
            />
        </>
    );
};

export default PlanList;
